/**
 * Created by daniel on 22/04/17.
 */

import React, {Component} from 'react';
import {IconButton, Toolbar, ToolbarGroup} from "material-ui";
import { yellow500} from "material-ui/styles/colors";
import {
  ActionDelete, ActionSettings, ActionVisibility, ActionVisibilityOff, NavigationClose,
} from "material-ui/svg-icons/index";

class ContentFrame extends Component {

  render() {
    let itemBounds = this.props.position;
    if (!itemBounds) return null;
    let tooHigh = itemBounds.top - 56 < 56;
    // 56 offset
    let contentFrameStyle = {
      position: "absolute",
      top: tooHigh ? itemBounds.top + 46 : itemBounds.top,
      left: itemBounds.left - 10,
      width: itemBounds.width,
      height: itemBounds.height + 46,
      borderColor: yellow500,
      borderStyle: "solid",
      borderWidth: "10px",
      pointerEvents: "none",
      boxShadow: "rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px",
      zIndex: 10,
    };
    
    let toolbarStyles = {
      backgroundColor: yellow500,
      pointerEvents: "auto",
      bottom: tooHigh ? 0 : undefined,
      top: tooHigh ? undefined : 0,
      marginTop: tooHigh ? 0 : -10,
      marginBottom: tooHigh ? -10 : 0,
      width: "100%",
      position: "absolute"
    };

    
    let infoButton = (
      <IconButton
        tooltip={this.props.title}
        tooltipPosition="top-center"
      >
        <ActionSettings/>
      </IconButton>
    );
    
    let hideButton = (
      <IconButton
        onTouchTap={this.props.hideItem}
        tooltip={"Hide item"}
        tooltipPosition="top-center"
      >
        <ActionVisibilityOff/>
      </IconButton>
    );
    
    let showButton = (
      <IconButton
        onTouchTap={this.props.showItem}
        tooltip={"Unhide item"}
        tooltipPosition="top-center"
      >
        <ActionVisibility/>
      </IconButton>
    );
    
    let deleteButton = (
      <IconButton
        onTouchTap={this.props.delete}
        tooltip={"Delete item"}
        tooltipPosition="top-center"
      >
        <ActionDelete/>
      </IconButton>
    );
    
    let closeButton = (
      <IconButton
        onTouchTap={this.props.closeFrame}
        tooltip={"Close content frame"}
        tooltipPosition="top-center"
      >
        <NavigationClose/>
      </IconButton>
    );
    
    return (
      <div >
        <div style={contentFrameStyle}>
          <Toolbar
            style={toolbarStyles}
            onClick={(e)=> e.stopPropagation()}
            onDragStart={(e)=> {
              e.stopPropagation();
              e.preventDefault();
              return false;
            }}
          >
            <ToolbarGroup firstChild={true}>
              {infoButton}
              {this.props.hideable && this.props.hidden && showButton}
              {this.props.hideable && !this.props.hidden && hideButton}
            </ToolbarGroup>
            <ToolbarGroup lastChild={true}>
              {this.props.canDelete && deleteButton}
              {closeButton}
            </ToolbarGroup>
          </Toolbar>
        </div>
      </div>
    );
  }
}
export default ContentFrame;


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/ContentFrame.js